module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"country":"Country","layer":"Change","data_selection":"Data Selection","map":"Map"},"nl":{"country":"Land","layer":"Gegevens","data_selection":"Selecteer gegevens","map":"Kaart"}}')
  delete Component.options._Ctor
}
